import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import CarrosselBanners from './interfaces/CarrosselBanners';
import BannersWithDescription from './interfaces/BannersWithDescription';
import DescriptionText from './interfaces/DescriptionText';
import FeatureFilter from './interfaces/FeatureFilter';
import FocusText from './interfaces/FocusText';
import GridOfBanners from './interfaces/GridOfBanners';
import VerticalRedirectableLinks from './interfaces/VerticalRedirectableLinks';
import SingleBanner from './interfaces/SingleBanner';
import MediaYoutube from './interfaces/MediaYoutube';
import ProductGrid from './interfaces/ProductGrid';
import PopUp from './interfaces/PopUp';
import RedirectableLinks from './interfaces/RedirectableLinks';
import TitleWithRedirect from './interfaces/TitleWithRedirect';
import SingleProduct from './interfaces/SingleProduct';
import ProductCarousel from './interfaces/ProductCarousel';
import StoriesCarousel from './interfaces/StoriesCarousel';
import HighlightBar from './interfaces/HighlightBar';

export function returnInterfaceBySlug(item: ItemDynamicPageInPhone) {
	switch (item.slug) {
		case 'banners-with-description':
			return <BannersWithDescription item={item} />;

		case 'banner-carousel':
			return <CarrosselBanners item={item} />;

		case 'description-text':
			return <DescriptionText />;

		case 'featured-filter':
			return <FeatureFilter />;

		case 'focus-text':
			return <FocusText item={item} />;

		case 'grid-of-banners':
			return <GridOfBanners item={item} />;

		case 'vertical-redirectable-links':
			return <VerticalRedirectableLinks />;

		case 'product-grid':
			return <ProductGrid item={item} />;

		case 'single-banner':
			return <SingleBanner item={item} />;

		case 'media-youtube':
			return <MediaYoutube item={item} />;

		case 'popup':
			return <PopUp />;

		case 'redirectable-links':
			return <RedirectableLinks item={item} />;

		case 'title-with-redirect':
			return <TitleWithRedirect item={item} />;

		case 'single-product':
			return <SingleProduct item={item} />;

		case 'product-carousel':
			return <ProductCarousel item={item} />;

		case 'stories-carousel':
			return <StoriesCarousel item={item} />;

		case 'highlight-bar':
			return <HighlightBar item={item} />;

		default:
			return <p>Erro no tipo do módulo, contatar equipe Mondelez.</p>;
	}
}
